import { IonCol, IonRow, IonText } from "@ionic/react";
import { useEffect } from "react";
import { makeGETRequest } from "../../request/rawRequest";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import "../generalCSS/stylesheet.css";
import "../IonColor/color.css";

interface ContainerProps {
  pathLogo: string;
}
const NotValid: React.FC<ContainerProps> = ({ pathLogo }) => {
  useEffect(() => {
    makeGETRequest("/me").then((response: any) => {
      if (response.validated) {
        window.location.href = "/welcome";
      }
    });
  }, []);

  return (
    <BasicPage
      title="Votre compte est en cours de validation..."
      subtitle=""
      pathLogo={pathLogo}
      sizeLg="4"
      sizeSm="8"
    >
      <IonRow>
        <IonCol>
          <IonText color="black">
            <h1 style={{ textAlign: "center" }}>
              Votre compte sera validé sous 72h,
            </h1>
          </IonText>
          <IonText color="black">
            <h1 style={{ textAlign: "center" }}>Si ce n'est pas le cas :</h1>
          </IonText>
          <IonText color="grey">
            <h3 style={{ textAlign: "center" }}>En semaine de 9h à 18h</h3>
            <h3 style={{ textAlign: "center" }}>
              Sauf le mercredi de 9h à 12h
            </h3>
          </IonText>
          <IonText color="black">
            <h1 style={{ textAlign: "center" }}>05 56 48 28 10</h1>
          </IonText>
          <IonText color="black">
            <h1 style={{ textAlign: "center" }}>
              N'hésitez pas à nous appeler.
            </h1>
          </IonText>
        </IonCol>
      </IonRow>
    </BasicPage>
  );
};

export default NotValid;
